
import { AlertCircle, RefreshCw } from "lucide-react";

const PostCallFallback = ({
  title,
  icon,
  message,
  deadlineExpired = false,
  onRetry,
  isRetrying = false,
  retryLabel = "Retry",
  retryingLabel = "Retrying…",
}) => {
  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50 p-6 text-neutral-700">
      <h3 className="mb-2 flex items-center gap-2 font-medium text-blue-700">
        {icon || <AlertCircle size={20} />}
        {title}
      </h3>

      <p className="text-sm">{message}</p>

      {!deadlineExpired && onRetry && (
        <button
          type="button"
          onClick={onRetry}
          disabled={isRetrying}
          className="mt-3 inline-flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <RefreshCw
            className={`h-4 w-4 ${isRetrying ? "animate-spin" : ""}`}
          />
          {isRetrying ? retryingLabel : retryLabel}
        </button>
      )}
    </div>
  );
};

export default PostCallFallback;
